module.exports = __webpack_public_path__ + "static/assets/3ae0498a801ac158e1512459720d18fc.png";